import {IImportHrFile, IRuleset} from "../../../index";

type TDiffKey = "newfull" | "newonly" | "intersect" | "oldonly" | "oldfull";

type TIds = {
    [key in TDiffKey]: number[] | null
}

interface IDiffParams {
    ids: TIds
    diffKey: KnockoutObservable<TDiffKey | null>
}

interface IDiffButton {
    count: KnockoutObservable<number | null>
    label: string
    title: string
    key: string
}
